import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=7b2010e6&scoped=true"
import script from "./Drawers.vue?vue&type=script&lang=js"
export * from "./Drawers.vue?vue&type=script&lang=js"
import style0 from "./Drawers.vue?vue&type=style&index=0&id=7b2010e6&prod&scoped=true&lang=css"
import style1 from "./Drawers.vue?vue&type=style&index=1&id=7b2010e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2010e6",
  null
  
)

export default component.exports